import { render } from "./RegistroDatosPersonales.vue?vue&type=template&id=696dc864&scoped=true"
import script from "./RegistroDatosPersonales.vue?vue&type=script&lang=js"
export * from "./RegistroDatosPersonales.vue?vue&type=script&lang=js"

import "./RegistroDatosPersonales.vue?vue&type=style&index=0&id=696dc864&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696dc864"]])

export default __exports__